<template>
    <h1></h1>
</template>

<script>
//用户激活反馈
import { onMounted,toRef } from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const router = useRouter();
    const {t}=useI18n()
    onMounted(() => {
      let r = getQueryString("result");//从地址栏中取得uid
      if(r==='ok')
      {
        ElMessageBox.alert(
                t('vdusermessage.title'),
                t('vdusermessage.success'),
                {
                  confirmButtonText: "OK",
                  callback:()=>{
                    router.push('querymap')        
                  }
                }
              );
      }
      else
      {
        ElMessageBox.alert(
                t('vdusermessage.title'),
                t('vdusermessage.failed'),
                {
                  confirmButtonText: "OK",
                  callback:()=>{
                    router.push('querymap')        
                  }
                }
              );
      }
    });
    function getQueryString(name) {
      var after = window.location.hash;
      if (after.indexOf("?") === -1) return null; //如果url中没有传参直接返回空

      //key存在先通过search取值如果取不到就通过hash来取
      after = after.substr(2);

      if (after) {
        var reg = new RegExp("[?&]" + name + "=([^&]+).*$");
        var r = after.match(reg);
        if (r != null) {
          return decodeURIComponent(r[1]);
        } else {
          return null;
        }
      }
    }
    return{...toRef(t)}
    
  },
};
</script>